import { type hfb } from "@repo/api";
import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { hasItems, logError, trackAnalytics } from "@repo/utils";
import { useState } from "react";

import { ModalSheet } from "../../components/ModalSheet";
import { SearchSelect } from "../../components/SearchSelect";
import { useBokaHfbs, useOrderedDepartments } from "../../hooks/useCMP";

interface SelectDepartmentModalProps {
  isOpen: boolean;
  closeModal: () => void;
  selected: hfb[];
  onUpdate?: (hfbs: hfb[]) => void;
  onAsyncUpdate?: (hfbs: hfb[]) => Promise<void>;
  allowEmpty?: boolean;
  useBokaConfig?: boolean;
}
export const SelectDepartmentModal = ({
  isOpen,
  closeModal,
  selected,
  onUpdate,
  onAsyncUpdate,
  allowEmpty = true,
  useBokaConfig,
}: SelectDepartmentModalProps) => {
  const defaultDepartments = useOrderedDepartments();
  const bokaDepartments = useBokaHfbs();
  const departments = useBokaConfig ? bokaDepartments : defaultDepartments;
  const [localSelected, setLocalSelected] = useState<hfb[]>(selected);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <ModalSheet
      visible={isOpen}
      onClose={closeModal}
      title={t("label.department")}
      onBack={() => {
        closeModal();
        trackAnalytics("back_from_department");
      }}
      footer={
        <Button
          type="primary"
          // TODO: revisit and fix

          onClick={async () => {
            if (onUpdate) {
              onUpdate(localSelected);
              closeModal();
            } else if (onAsyncUpdate) {
              setLoading(true);
              try {
                await onAsyncUpdate(localSelected);
              } catch (error) {
                logError(error);
                trackAnalytics("update_department_failed");
              } finally {
                setLoading(false);
                closeModal();
              }
            }
            trackAnalytics("save_department");
          }}
          loading={loading}
          text={t("action.save")}
          disabled={allowEmpty ? false : !hasItems(localSelected)}
        />
      }
    >
      <SearchSelect
        localState={localSelected ?? []}
        onChange={(_checked, _item, items) => {
          setLocalSelected(items as hfb[]);
          trackAnalytics("select_department");
        }}
        selectionMode="MULTI"
        values={departments}
        selectAll
      />
    </ModalSheet>
  );
};
